/**
 * Cancel Subscription Modal Content
 * Content for the cancel subscription confirmation modal
 */

import { AlertTriangle } from 'lucide-react';
import React from 'react';

interface CancelSubscriptionContentProps {
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export const CancelSubscriptionContent: React.FC<
  CancelSubscriptionContentProps
> = ({ onConfirm, onCancel, isLoading }) => {
  return (
    <div className="text-center">
      <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 flex items-center justify-center">
        <AlertTriangle size={32} className="text-red-500" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        Cancel Subscription?
      </h3>
      <p className="text-gray-600 mb-6">
        Your subscription will remain active until the end of the current
        billing period. You can resume anytime before then.
      </p>
      <div className="flex gap-3">
        <button
          type="button"
          onClick={onCancel}
          disabled={isLoading}
          className="flex-1 py-2.5 px-4 border border-gray-300 text-gray-700 font-semibold rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
        >
          Keep Subscription
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={isLoading}
          className="flex-1 py-2.5 px-4 bg-red-500 text-white font-semibold rounded-lg hover:bg-red-600 transition-colors disabled:opacity-50"
        >
          {isLoading ? 'Canceling...' : 'Yes, Cancel'}
        </button>
      </div>
    </div>
  );
};
